import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
	GET_HELP_CENTER_LINKS_REQUEST: '',
	GET_HELP_CENTER_LINKS_SUCCESS: '',
	GET_HELP_CENTER_LINKS_FAILURE: ''
};

types = setStoreTypeValues(types, 'helpCenter');

export default types;
